<template>
    <div v-if="filters">
        <selected-filters
            :selected="filterValues"
            :translatable="['refundable', 'class', 'baggage']"
            @delete-filter="clearFilter"
        />
        <price-filter
            v-if="filters.price && filters.price[1] !== Infinity && filters.price[1]"
            :filter-values="filterValues"
            :filters="filters"
            :label="$t('price')"
            :currency="currency"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.supplierName && filters.supplierName.length > 1 && isTO1"
            :filter-values="filterValues"
            :filters="filters"
            filter="supplierName"
            @change="change($event)"
        />
        <name-filter :filter-values="filterValues" :filters="filters" filter="flightNumber" @change="change($event)" />
        <checkbox-filter
            v-if="filters.stops && filters.stops.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="stops"
            :pluralization="true"
            :translate-labels="true"
            @change="change($event)"
        />
        <range-filter
            v-if="filters.duration && filters.duration[1] !== Infinity && filters.duration[1]"
            :filters="filters"
            filter="duration"
            :pluralization="true"
            value-filter="durationFormat"
            :label="$t('filterTitles.duration')"
            @change="change($event)"
        />
        <range-filter
            v-if="filters.startTime"
            :filters="filters"
            filter="startTime"
            value-filter="durationFormat"
            :label="$t('filterTitles.flightStartTime')"
            @change="change($event)"
        />
        <range-filter
            v-if="filters.endTime"
            :filters="filters"
            filter="endTime"
            value-filter="durationFormat"
            :label="$t('filterTitles.flightEndTime')"
            @change="change($event)"
        />
        <checkbox-filter-grouped
            v-if="filters.airport && filters.airport.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="airport"
            @change="change($event)"
        >
            <v-col cols="12">
                <checkbox-single-filter
                    v-if="filters.airport && filters.airport.length > 1"
                    :filter-values="filterValues"
                    :filters="filters"
                    :label="$t('depart_return_same_airports')"
                    filter="isSameAirport"
                    @change="change($event)"
                />
            </v-col>
        </checkbox-filter-grouped>
        <checkbox-filter
            v-if="filters.transferAirport && filters.transferAirport.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="transferAirport"
            :pluralization="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.airline && filters.airline.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="airline"
            :pluralization="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.baggage && filters.baggage.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="baggage"
            :translate-labels="true"
            :pluralization="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.brandedFareName && filters.brandedFareName.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="brandedFareName"
            :pluralization="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.class && filters.class.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="class"
            :translate-labels="true"
            :pluralization="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.refundable && filters.refundable.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="refundable"
            :pluralization="false"
            :translate-labels="true"
            @change="change($event)"
        />
        <filtered-mobile-button
            v-if="$breakpoint.smAndDown"
            class="sticky-button"
            :count="filteredOffersCount"
            :visible="Object.keys(filterValues).length > 0"
            @change-mode="goToOffers"
            @clear-filters="reset"
        />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import PriceFilter from '~src/components/search/filters/priceFilter.src'
    import CheckboxFilter from '@/components/search/filters/CheckboxFilter.vue'
    import CheckboxSingleFilter from '@/components/search/filters/CheckboxSingleFilter.vue'
    import FilteredMobileButton from '~/components/snippets/FilteredMobileButton.vue'
    import NameFilter from '~/components/filters/NameFilter.vue'
    import SelectedFilters from '~/components/snippets/SeletedFilters.vue'
    import RangeFilter from '~/components/search/filters/RangeFilter.vue'
    import {FiltersBase} from '~/components/search/FiltersBase.vue'
    import CheckboxFilterGrouped from '@/components/search/filters/CheckboxFilterGrouped.vue'

    @Component({
        components: {
            PriceFilter,
            CheckboxFilter,
            CheckboxSingleFilter,
            FilteredMobileButton,
            NameFilter,
            SelectedFilters,
            RangeFilter,
            CheckboxFilterGrouped,
        },
    })
    export class FlightFilters extends FiltersBase {}

    export default FlightFilters
</script>
